export default "__VITE_ASSET__C$JFawUK__"